import { connect } from 'react-redux';

import { deselectMessages } from '../../actions/chatActions';
import { buildAndSendExportToInbox, sendExportToInbox } from '../../actions/pdfActions';

import ChatPanelOverview from './ChatPanelOverview';

const mapStateToProps = (state, ownProps) => ({
  identity: state.identity,
  pdf: state.pdf[ownProps.chat.id] ? state.pdf[ownProps.chat.id] : {},
});

const mapDispatchToProps = dispatch => ({
  cancelSelectMessages: chatId => dispatch(deselectMessages(chatId)),
  buildAndSendExportToInbox: chatId => dispatch(buildAndSendExportToInbox(chatId)),
  sendExportToInbox: chatId => dispatch(sendExportToInbox(chatId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatPanelOverview);
